const Helper = {};

import { mapState, mapActions } from 'vuex'

Helper.install = function(Vue, options) {


    Vue.mixin({
        data: function() {
            return {
                // ImageUrl: 'http://localhost:8000/uploads/',
                // StaticImageUrl: 'http://localhost:8080/',
                // socketUrl: 'http://localhost:3000',

                ImageUrl: 'https://dl.arzine.org/uploads/',
                StaticImageUrl: 'https://arzine.org/',
                socketUrl: 'https://node.arzine.org'
            }
        },
        computed: {
            ...mapState([
                'sidebarState',
                'authenticated',
                'userData',
                'stateLoading',
                'user_number',
                'user_email',
                'state_notifications',
                'state_setting',
                'state_bank_accounts',
                'state_wallets',
                'state_converting',
                'state_notifications_count',
                'state_prices',
            ])
        },
        methods: {
            ...mapActions([
                'StoreAuthStatus',
                'StoreGuestNumber',
                'StoreNumber',
                'StoreUserData',
                'UserLogout',
                'notificationCount',
                'activeLoading',
                'toggleSidebar',
                'changeSidebarState',
                'StoreNotifications',
                'StoreSetting',
                'StoreBankAccounts',
                'StorePrice',
            ]),
            InsertJustNumber(e) {
                const isNumeric = /^[-+]?(\d+|\d+\.\d*|\d*\.\d+)$/;
                const value = e.target.value;
                if (!isNumeric.test(value)) {
                    e.target.value = ''
                }
            },
            formatPrice(value) {
                // let val = (value/1).replace('.', '')
                // return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "،")
                if (value) {
                    const number = parseInt(value)
                    const val = Number((number).toFixed(1)).toLocaleString()
                    return val
                } else {
                    return value
                }
            },
            just_float(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            just_latin(evt) {
                var p = /^[\u0600-\u06FF\s]+$/;
                if (p.test(evt.key)) {
                    evt.preventDefault();
                }
            },
            dont_allow_number(evt) {
                var p = /[^0-9]/g;
                if (!p.test(evt.key)) {
                    evt.preventDefault();
                }
            },
            allow_phone_number(evt) {
                var p = /[^0-9]/g;
                if (p.test(evt.key)) {
                    evt.preventDefault();
                }
                if (evt.target.value.length >= 11) {
                    console.log(true);
                    evt.preventDefault();
                }
            }
        }
    });

};

export { Helper as default };